import { z } from 'zod';

const safeLink = z
  .string()
  .max(2000)
  .refine((value) => {
    try {
      return ['https:', 'http:', 'mailto:'].includes(new URL(value).protocol);
    } catch {
      return false;
    }
  }, 'Use an explicit http, https or mailto link');
const mark = z.discriminatedUnion('type', [
  z.object({ type: z.enum(['bold', 'italic', 'code']) }).strict(),
  z.object({ type: z.literal('link'), href: safeLink }).strict(),
]);
const text = z
  .object({
    type: z.literal('text'),
    text: z.string().max(100000),
    marks: z.array(mark).max(4).optional(),
  })
  .strict();
const paragraph = z
  .object({ type: z.literal('paragraph'), content: z.array(text).max(1000) })
  .strict();
export const richTextDocumentSchema = z
  .object({
    type: z.literal('doc'),
    content: z
      .array(
        z.union([
          paragraph,
          z
            .object({
              type: z.literal('heading'),
              level: z.number().int().min(1).max(4),
              content: z.array(text).max(1000),
            })
            .strict(),
          z
            .object({
              type: z.literal('list'),
              ordered: z.boolean(),
              content: z.array(paragraph).max(1000),
            })
            .strict(),
        ]),
      )
      .max(1000),
  })
  .strict()
  .refine((value) => JSON.stringify(value).length <= 1048576, 'Document is too large');
